var _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTokenPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 105.833 105.833",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52.652,
    cy: 51.858,
    r: 20.505,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.794
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.652,
    cy: 51.858,
    r: 15.875,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.794
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.652,
    cy: 51.858,
    r: 11.245,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 0.794
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.652,
    cy: 51.858,
    r: 5.777,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenPlaceholder);
export default __webpack_public_path__ + "static/media/token-placeholder.4b9ef93b3bf30175f06035acf8b7765b.svg";
export { ForwardRef as ReactComponent };